module.exports = __webpack_public_path__ + "img/badminton.89376222.jpg";